/*
  Restock · página única (sep-2026). El hub arriba y, debajo, el producto elegido.
  El arranque (grupo inicial y etiquetado de secciones) va inline en sections/restock-pagina.liquid
  para que el grupo oculto no llegue a pintarse; aquí va el cambio de grupo sin recargar:
  - Clic en cualquier elemento con [data-rs-ver-link="<grupo>"] (tarjetas del hub, navegación, selector
    final), o en un enlace de un texto a …?ver=<grupo|alias> o #<grupo|alias>. Si la página no tiene ese grupo,
    se sigue el enlace normal.
  - Marca la tarjeta y el enlace de la navegación activos, cambia ?ver= en la URL (replaceState),
    baja al inicio del producto y avisa con el evento `rs:ver` (lo escuchan restock-aceite.js y etn-landing.js).
  - Personalizador: al seleccionar una sección de otro grupo, se cambia a ese grupo.
  FASES (TEASE/HYPE/BUY por producto, Configuración del tema → «Restock · fases»; datos en FHRestockPagina.cfg.fases):
  - La fase se calcula aquí con la hora de Madrid (la página puede venir cacheada de antes de la fecha). Si la
    tarjeta o la navegación que pintó el servidor no cuadran ([data-rs-srv]), se piden de nuevo por Section
    Rendering API sin caché (?sections=…&_rs=minuto) y se sustituyen.
  - Aceites 2 y 3: su contenido no está en esta página. Al elegirlos ya desvelados, se pide
    ?view=restock-aceite2 (layout restock-oculto: vacío mientras están en TEASE), se meten sus secciones
    debajo del hub y se ejecutan sus scripts.
  - Antetítulo y llamada de la tarjeta cambian solos de HYPE a BUY ([data-rs-eb-hype] / [data-rs-cta-hype]).
  CARPETA (restock-grid «Tarjeta unida al contenido», <html data-rsp>): panelEnds() pone .rsp-last en la última
  sección visible del producto (esquinas inferiores de la burbuja) y .rsp-void en las que salen vacías.
  - QA: ?fase=tease|hype|buy&ver=<producto> fuerza la fase en el navegador (el contenido de un aceite aún en
    TEASE solo se puede ver en el Personalizador o en la página de vista previa).
*/
(function(){
  if(window.FHRestockPaginaJS)return;window.FHRestockPaginaJS=true;
  var P=window.FHRestockPagina;if(!P)return;
  var CFG=P.cfg||{},FASES=CFG.fases||{},VIEWS=CFG.views||{};
  // Productos de esta página y cuáles siguen una fase: los da la sección (ajuste «Productos de esta página»)
  var doc=document,html=doc.documentElement,GR=CFG.grupos||['eucalipto','etnalia','aceite2','aceite3'];
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FK=CFG.fk||['eucalipto','aceite2','aceite3'];
  var qs;try{qs=new URLSearchParams(location.search)}catch(e){qs={get:function(){return null}}}

  /* ── FASES ─────────────────────────────────────────────────────────────────────── */
  function madrid(d,h){
    var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec((d||'').trim()),t=/^(\d{1,2}):(\d{2})$/.exec((h||'00:00').trim());
    if(!m||!t)return NaN;
    var guess=Date.UTC(+m[1],+m[2]-1,+m[3],+t[1],+t[2]);
    try{
      var parts={};new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Madrid',hourCycle:'h23',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit'}).formatToParts(new Date(guess)).forEach(function(x){parts[x.type]=x.value});
      return guess-(Date.UTC(+parts.year,+parts.month-1,+parts.day,+parts.hour,+parts.minute)-guess);
    }catch(e){return guess-2*3600e3}
  }
  function faseReal(k){ // sin ?fase= de previsualización
    var f=FASES[k];if(!f)return 'buy';
    if(f.fm==='tease'||f.fm==='hype'||f.fm==='buy')return f.fm;
    var n=Date.now(),th=madrid(f.hype[0],f.hype[1]),tb=madrid(f.buy[0],f.buy[1]);
    if(!isNaN(tb)&&n>=tb)return 'buy';
    if(isNaN(th)||n>=th)return 'hype';
    return 'tease';
  }
  function fase(k){
    var ed=CFG.editor;if(ed&&(ed.producto==='todos'||ed.producto===k))return ed.fase;
    var pf=qs.get('fase'),pv=qs.get('ver');
    if(pv&&GR.indexOf(pv)<0)pv=alias(pv);
    if((pf==='tease'||pf==='hype'||pf==='buy')&&(!pv||pv===k))return pf;
    return faseReal(k);
  }
  function fased(k){return FK.indexOf(k)>-1&&!!FASES[k]}
  // «Mostrar en la fase» de secciones y bloques ([data-rs-mostrar]: tease · hype · buy · hype_buy · tease_hype)
  function applyFases(){
    // Secciones comunes que no se enseñan con ciertos productos (data-rs-ocultar="etnalia,aceite2")
    var vv=current();
    doc.querySelectorAll('[data-rs-ocultar]').forEach(function(el){
      var lst=(el.getAttribute('data-rs-ocultar')||'').split(',').map(function(x){return x.trim()});
      el.classList.toggle('rs-grupo-off',lst.indexOf(vv)>-1);
    });
    doc.querySelectorAll('[data-rs-mostrar]').forEach(function(el){
      var sub=el.closest('[data-rs-prod]'),g;
      if(sub&&sub!==el)g=sub.getAttribute('data-rs-prod');
      else{var sec=el.classList.contains('shopify-section')?el:el.closest('.shopify-section');g=sec&&sec.getAttribute('data-rs-grupo')}
      if(el.hasAttribute('data-rs-prod'))g=el.getAttribute('data-rs-prod');
      var m=el.getAttribute('data-rs-mostrar')||'todas',on=true;
      if(m!=='todas'&&g&&g!=='siempre'){var f=fased(g)?fase(g):'buy';on=m.split('_').indexOf(f)>-1}
      el.classList.toggle('rs-fase-off',!on);
    });
  }
  window.FHRestockPagina.applyFases=applyFases;

  // Carpeta: cierre de la burbuja del producto que se ve (restock-carpeta.css)
  function panelEnds(){
    if(!html.hasAttribute('data-rsp'))return;
    var v=current();
    doc.querySelectorAll('.rsp-last,.rsp-void').forEach(function(el){el.classList.remove('rsp-last','rsp-void')});
    if(!v)return;
    var vis=[];
    sections(v).forEach(function(el){
      if(el.classList.contains('rs-fase-off'))return;
      if(el.offsetHeight<=2){el.classList.add('rsp-void');return}
      vis.push(el);
    });
    if(vis.length)vis[vis.length-1].classList.add('rsp-last');
    var t=teaser(v);if(t&&!vis.length)t.classList.add('rsp-last');
  }
  window.FHRestockPagina.panelEnds=panelEnds;
  function revealed(k){return !fased(k)||CFG.siempre||fase(k)!=='tease'}

  function sections(g){return doc.querySelectorAll('.shopify-section[data-rs-grupo="'+g+'"]')}
  // secciones que llevan un bloque por producto (una sola sección sirve para varios grupos)
  function multis(){return doc.querySelectorAll('[data-rs-multi]')}
  function multiHas(g){
    var out=false;
    multis().forEach(function(m){if((m.getAttribute('data-rs-multi')||'').split(',').indexOf(g)>-1)out=true});
    return out;
  }
  // aceites por desvelar: su bloque «Por desvelar» vive dentro de la grid del hub (restock-grid), sin sección propia
  function teaser(g){return doc.querySelector('[data-rs-teaser="'+g+'"]')}
  function has(g){
    if(GR.indexOf(g)<0)return false;
    if(fased(g)&&!revealed(g))return !!teaser(g);
    return sections(g).length>0||multiHas(g)||!!VIEWS[g]||!!teaser(g);
  }
  function current(){return html.getAttribute('data-rs-ver')}

  function marks(){
    var v=current();
    doc.querySelectorAll('[data-rs-ver-link]').forEach(function(el){
      var on=el.getAttribute('data-rs-ver-link')===v;
      el.classList.toggle('is-active',on);
      if(el.classList.contains('rsn__item')){
        el.classList.toggle('rsn__item--active',on);
        if(on)el.setAttribute('aria-current','true');else el.removeAttribute('aria-current');
      }else if(el.matches('a,button')){
        el.setAttribute('aria-pressed',on?'true':'false');
      }
    });
    // la tarjeta activa del carril móvil queda a la vista
    doc.querySelectorAll('.rsg--large .rsg__grid').forEach(function(g){
      var a=g.querySelector('.is-active');if(!a||g.scrollWidth<=g.clientWidth)return;
      var li=a.closest('li')||a;g.scrollTo({left:Math.max(0,li.offsetLeft-20),behavior:reduce?'auto':'smooth'});
    });
    doc.querySelectorAll('.rsn__list').forEach(function(l){
      var a=l.querySelector('.rsn__item--active');if(!a||l.scrollWidth<=l.clientWidth)return;
      var li=a.parentNode;l.scrollLeft=Math.max(0,li.offsetLeft-(l.clientWidth-li.offsetWidth)/2);
    });
  }

  function navHeight(){
    var n=doc.querySelector('.rsn');if(!n)return 0;
    var r=n.getBoundingClientRect();return r.height>0&&r.top<=1?r.height:(r.height||0);
  }
  function scrollToGroup(g,instant,anchor){
    var first=sections(g)[0]||teaser(g);if(!first)return;
    if(!sections(g).length){ // solo el bloque «Por desvelar»: que quede a la vista, sin taparlo la navegación
      var r=first.getBoundingClientRect(),vh=window.innerHeight;
      if(r.top>=navHeight()&&r.bottom<=vh)return;
    }
    var target=first;
    if(anchor){try{var a=doc.getElementById(anchor);if(a&&a.getClientRects().length)target=a}catch(e){}}
    var y=target.getBoundingClientRect().top+window.pageYOffset-navHeight();
    window.scrollTo({top:Math.max(0,y),behavior:(instant||reduce)?'auto':'smooth'});
  }

  /* ── CONTENIDO DE LOS ACEITES 2 Y 3 (otra plantilla) ─────────────────────────────── */
  var loads={};
  function bucket(){return Math.floor(Date.now()/60000)}
  // Vista previa de un tema sin publicar: las peticiones tienen que ir a ese mismo tema
  function extra(){
    var x='';
    try{if(/myshopify\.com$/.test(location.hostname))x+='&_fd=0'}catch(e){}
    try{if(window.Shopify&&Shopify.theme&&Shopify.theme.role&&Shopify.theme.role!=='main')x+='&preview_theme_id='+Shopify.theme.id}catch(e){}
    return x;
  }
  function mainEl(){var me=doc.getElementById(CFG.me);return me&&me.parentNode}
  function runScripts(root){
    root.querySelectorAll('script').forEach(function(old){
      var type=(old.getAttribute('type')||'').toLowerCase();
      if(type&&type!=='text/javascript'&&type!=='module')return;
      var s=doc.createElement('script');
      for(var i=0;i<old.attributes.length;i++)s.setAttribute(old.attributes[i].name,old.attributes[i].value);
      if(!old.src)s.textContent=old.textContent;
      old.parentNode.replaceChild(s,old);
    });
  }
  function insertionPoint(main){ // antes de las secciones «siempre» del final (selector de cierre)
    var kids=[].filter.call(main.children,function(el){return el.classList&&el.classList.contains('shopify-section')});
    var i=kids.length;while(i>0&&kids[i-1].getAttribute('data-rs-grupo')==='siempre')i--;
    return kids[i]||null;
  }
  function needsLoad(g){return !!VIEWS[g]&&revealed(g)&&!sections(g).length&&!multiHas(g)}
  function loadContent(g){
    if(loads[g])return loads[g];
    var u=location.pathname+'?view='+encodeURIComponent(VIEWS[g])+'&_rs='+bucket()+extra();
    html.setAttribute('data-rs-cargando',g);
    loads[g]=fetch(u,{credentials:'same-origin'}).then(function(r){return r.ok?r.text():''}).then(function(txt){
      var main=mainEl();if(!txt||!main)return false;
      var d=new DOMParser().parseFromString(txt,'text/html'),m=d.getElementById('MainContent');
      var secs=m?[].filter.call(m.children,function(el){return el.classList&&el.classList.contains('shopify-section')}):[];
      // solo secciones de ese producto (con su marca de grupo): si la plantilla no existe, Shopify devuelve la de página normal
      if(!secs.length||!secs[0].querySelector('[data-rs-grupo-mark="'+g+'"]'))return false;
      if(sections(g).length)return true; // ya cargado por otra vía
      var at=insertionPoint(main);
      secs.forEach(function(s){var n=doc.importNode(s,true);main.insertBefore(n,at);runScripts(n)});
      if(P.part)P.part();
      panelEnds();
      doc.dispatchEvent(new CustomEvent('rs:contenido',{detail:{ver:g}}));
      return true;
    }).catch(function(){return false}).then(function(ok){
      html.removeAttribute('data-rs-cargando');
      if(!ok)loads[g]=null;
      return ok;
    });
    return loads[g];
  }

  /* ── HUB: tarjetas y navegación según la fase ────────────────────────────────────── */
  var hubBusy=false,hubTries=0;
  function hubMismatch(){
    if(CFG.editor||(window.Shopify&&Shopify.designMode))return false;
    var bad=false;
    doc.querySelectorAll('[data-rs-fase-card],[data-rs-fase-nav]').forEach(function(el){
      var k=el.getAttribute('data-rs-fase-card')||el.getAttribute('data-rs-fase-nav');
      if(!fased(k)||CFG.siempre)return;
      if(el.getAttribute('data-rs-srv')!==faseReal(k))bad=true;
    });
    return bad;
  }
  function contentMismatch(){
    if(CFG.editor||(window.Shopify&&Shopify.designMode))return false;
    if(!multis().length)return false;
    var bad=false;
    FK.forEach(function(k){if(fased(k)&&revealed(k)&&!multiHas(k))bad=true});
    return bad;
  }
  function refreshHub(){
    if(hubBusy||hubTries>5)return;
    var secs=[];
    doc.querySelectorAll('[data-rs-fase-card],[data-rs-fase-nav],[data-rs-multi]').forEach(function(el){
      var s=el.closest('.shopify-section');if(s&&secs.indexOf(s)<0)secs.push(s);
    });
    if(!secs.length)return;
    hubBusy=true;hubTries++;
    var ids=secs.map(function(s){return s.id.replace(/^shopify-section-/,'')});
    fetch(location.pathname+'?sections='+ids.map(encodeURIComponent).join(',')+'&_rs='+bucket()+extra(),{credentials:'same-origin'})
      .then(function(r){return r.ok?r.json():null})
      .then(function(j){
        if(!j)return;
        secs.forEach(function(old){
          var h=j[old.id.replace(/^shopify-section-/,'')];if(!h)return;
          var tmp=doc.createElement('div');tmp.innerHTML=h;
          var fresh=tmp.querySelector('.shopify-section')||tmp.firstElementChild;if(!fresh)return;
          old.parentNode.replaceChild(fresh,old);runScripts(fresh);
        });
        if(P.part)P.part();
        applyFases();marks();swapTexts();panelEnds();
        if(window.FHRestock&&FHRestock.init)FHRestock.init();
        doc.dispatchEvent(new CustomEvent('rs:hub'));
      })
      .catch(function(){})
      .then(function(){hubBusy=false});
  }
  function swapTexts(){
    doc.querySelectorAll('[data-rs-eb-hype]').forEach(function(el){
      var card=el.closest('[data-rs-fase-card]'),k=card&&card.getAttribute('data-rs-fase-card');if(!k)return;
      var buy=fase(k)==='buy',txt=buy?el.getAttribute('data-rs-eb-buy'):el.getAttribute('data-rs-eb-hype');
      var live=buy?el.hasAttribute('data-rs-eb-buy-live'):el.hasAttribute('data-rs-eb-hype-live');
      var t=el.querySelector('[data-rs-eb-txt]');if(t&&t.textContent!==txt)t.textContent=txt;
      el.classList.toggle('rsg__eyebrow--live',live);
    });
    doc.querySelectorAll('[data-rs-cta-hype]').forEach(function(el){
      var card=el.closest('[data-rs-fase-card]'),k=card&&card.getAttribute('data-rs-fase-card');if(!k)return;
      var txt=fase(k)==='buy'?el.getAttribute('data-rs-cta-buy'):el.getAttribute('data-rs-cta-hype');
      var t=el.querySelector('[data-rs-cta-txt]');if(t&&t.textContent!==txt)t.textContent=txt;
    });
  }
  function checkFases(){
    applyFases();
    swapTexts();
    panelEnds();
    if(hubMismatch()||contentMismatch())refreshHub();else hubTries=0;
    var v=current();
    if(v&&fased(v)&&!has(v)){ // su fase ha vuelto atrás o ya no está: al primero disponible
      for(var i=0;i<GR.length;i++){if(has(GR[i])){setVer(GR[i],{url:false});break}}
    }else if(v&&needsLoad(v)){setVer(v,{url:false})}
  }
  window.FHRestockPagina.fase=fase;

  function setVer(g,opts){
    opts=opts||{};
    if(!has(g))return false;
    if(needsLoad(g)){
      var prev=current();
      loadContent(g).then(function(ok){
        if(ok&&sections(g).length){var o2={};for(var k in opts)o2[k]=opts[k];o2.force=true;setVer(g,o2)}
        else if(prev&&prev!==g&&has(prev)&&!needsLoad(prev)){setVer(prev,{url:false})}
        else{for(var i=0;i<GR.length;i++){if(GR[i]!==g&&has(GR[i])&&!needsLoad(GR[i])){setVer(GR[i],{url:false,force:true});break}}}
      });
      return true;
    }
    var changed=current()!==g||!!opts.force;
    html.setAttribute('data-rs-ver',g);
    if(P.part)P.part();
    applyFases();
    marks();
    panelEnds();
    if(opts.url!==false){
      try{
        var u=new URL(location.href);u.searchParams.set('ver',aliasOf(g));
        history.replaceState(history.state,'',u.pathname+u.search+u.hash);
      }catch(e){}
    }
    if(changed){
      doc.dispatchEvent(new CustomEvent('rs:ver',{detail:{ver:g}}));
      // secciones que miden al hacer scroll/resize (barras fijas, carriles) se recalculan
      window.dispatchEvent(new Event('resize'));
      window.dispatchEvent(new Event('scroll'));
    }
    if(opts.scroll)requestAnimationFrame(function(){scrollToGroup(g,opts.instant,opts.anchor)});
    return true;
  }
  window.FHRestockPagina.setVer=setVer;

  doc.addEventListener('click',function(e){
    var t=e.target;if(!t.closest)return;
    var el=t.closest('[data-rs-ver-link]');if(!el)return;
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button>0)return;
    var g=el.getAttribute('data-rs-ver-link'),href=el.getAttribute('href')||'';
    if(!has(g))return;               // otra plantilla: se sigue el enlace
    var hash=href.charAt(0)==='#'?href.slice(1):'';
    if(hash&&g===current())return;   // ya se ve ese producto: el ancla hace lo suyo (#lista abre la lista, #oferta baja)
    e.preventDefault();
    // #lista: se cambia de producto y la ventana de alta se abre sola (restock-aceite.js); sin saltos de scroll
    setVer(g,{scroll:hash!=='lista',anchor:hash});
  });

  // Enlaces sueltos dentro de los textos (richtext de desplegables, FAQ…): /pages/…?ver=etnalia, ?ver=etnalia o
  // #etnalia cambian de producto sin recargar y bajan a su inicio, igual que las tarjetas. Solo si la página tiene
  // ese grupo; si no, el enlace se sigue normal (p. ej. desde el Personalizador de una plantilla suelta).
  doc.addEventListener('click',function(e){
    var t=e.target;if(!t.closest)return;
    var a=t.closest('a[href]');if(!a||a.hasAttribute('data-rs-ver-link'))return;
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button>0||a.target==='_blank')return;
    var raw=a.getAttribute('href')||'',u;
    try{u=new URL(raw,location.href)}catch(err){return}
    if(u.origin!==location.origin)return;
    // OJO: new URL('#molecula-x', location.href) HEREDA el ?ver= de la página. Sin este filtro, cualquier
    // ancla interna (#molecula-…, #lista) se tomaba por un enlace de producto y saltaba al hero.
    var q=raw.indexOf('ver=')>-1?u.searchParams.get('ver'):null,g=null;
    if(q&&(u.pathname===location.pathname||/^\/pages\//.test(u.pathname)))g=alias(q);
    if(!g&&!q&&raw.charAt(0)==='#'&&raw.length>1)g=alias(decodeURIComponent(raw.slice(1)));
    if(!g||!has(g))return;
    e.preventDefault();
    setVer(g,{scroll:true,force:g!==current()});
  });

  // ?ver=mandarina → el grupo de la tarjeta desvelada con ese «Nombre en el enlace» (data-rs-alias)
  function alias(q){
    if(!q||GR.indexOf(q)>-1)return q;
    var el=doc.querySelector('[data-rs-alias="'+String(q).replace(/"/g,'')+'"][data-rs-ver-link]');
    return el?el.getAttribute('data-rs-ver-link'):null;
  }
  function aliasOf(g){var el=doc.querySelector('[data-rs-alias][data-rs-ver-link="'+g+'"]');return el?el.getAttribute('data-rs-alias'):g}
  function start(){
    if(P.part)P.part();
    applyFases();
    var q0=qs.get('ver');
    if(q0&&GR.indexOf(q0)<0){
      var ga=alias(q0);
      if(ga){html.setAttribute('data-rs-ver',ga);P.fromUrl=true}
      else if(hubMismatch()){ // página cacheada de antes de desvelarse: al refrescar el hub se resuelve
        doc.addEventListener('rs:hub',function once(){doc.removeEventListener('rs:hub',once);var g2=alias(q0);if(g2)setVer(g2,{url:true,scroll:!!(P.cfg&&P.cfg.scroll),force:true})});
      }
    }
    swapTexts();
    if(hubMismatch()||contentMismatch())refreshHub();
    setInterval(checkFases,30000);
    var g=current();
    if(!has(g)){ // ?ver= a un grupo que no está en la página: el primero que haya
      for(var i=0;i<GR.length;i++){if(has(GR[i])){g=GR[i];break}}
    }
    setVer(g,{url:P.fromUrl||g!==P.initial});
    marks();
    panelEnds();
    window.addEventListener('load',panelEnds);
    if(P.cfg&&P.cfg.scroll&&(P.fromUrl||P.cfg.handle)&&!location.hash){
      window.addEventListener('load',function(){scrollToGroup(current(),true)});
    }
  }
  if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',start);else start();

  // Personalizador: secciones recargadas pierden su etiqueta de grupo; al elegir una de otro grupo, se muestra ese grupo
  if(window.Shopify&&Shopify.designMode){
    ['shopify:section:load','shopify:section:unload','shopify:section:reorder'].forEach(function(ev){
      doc.addEventListener(ev,function(){setTimeout(function(){if(P.part)P.part();applyFases();marks();panelEnds()},0)});
    });
    doc.addEventListener('shopify:section:select',function(e){
      if(P.part)P.part();
      var sec=doc.getElementById('shopify-section-'+(e.detail&&e.detail.sectionId));
      var g=sec&&sec.getAttribute('data-rs-grupo');
      if(g&&g!=='siempre'&&g!==current())setVer(g,{url:false});
    });
    // Al elegir un bloque (un producto, una pregunta, un beneficio…): se cambia a su producto, se abre si es un
    // desplegable y se baja hasta él. Un bloque «para todos» sale una vez por producto: vale el del producto que se ve.
    doc.addEventListener('shopify:block:select',function(e){
      var el=e.target;if(!el||!el.closest)return;
      if(P.part)P.part();
      var id=e.detail&&e.detail.blockId,cur=current(),sub=el.closest('[data-rs-prod]'),g=sub&&sub.getAttribute('data-rs-prod'),moved=false;
      if(g&&g!==cur){
        var same=null;
        if(id&&cur){
          var all=doc.querySelectorAll('[data-rs-prod="'+cur+'"] [data-shopify-editor-block]');
          for(var i=0;i<all.length;i++){if((all[i].getAttribute('data-shopify-editor-block')||'').indexOf('"'+id+'"')>-1){same=all[i];break}}
        }
        if(same){el=same;moved=true}
        else if(has(g)){setVer(g,{url:false});moved=true}
      }else if(!g){ // bloque de una sección de un solo grupo (las del difusor): se cambia a ese grupo
        var sec=el.closest('.shopify-section'),sg=sec&&sec.getAttribute('data-rs-grupo');
        if(sg&&sg!=='siempre'&&sg!==cur&&has(sg)){setVer(sg,{url:false});moved=true}
      }
      var d=el.closest('details');if(d&&!d.open)d.open=true;
      if(moved||d)setTimeout(function(){
        var r=el.getBoundingClientRect();
        if(r.height&&(r.top<80||r.top>window.innerHeight*.7))window.scrollTo({top:Math.max(0,r.top+window.scrollY-140),behavior:'auto'});
      },80);
    });
  }
})();
